import React from "react";
import Mydata from "../../data/blog/firstclass.json";
import style from "@/app/style/servicesetyle.module.css";
import Sticky from "../business-travellers-car-service-dallas/sticky";

function hero() {
  const item = Mydata[0];
  return (
    <>
      <div
        id={style.blogsiz}
        className={`flex items-end  ${style.blogfirstclass}`}
      >
        <div className=" opecit w-full ">
          <div
            className=" mb-8 w-full  
       mx-auto px-4 max-w-7xl px-3 "
          >
            <p className="bg-[#d5af34] p-2 mb-2 rounded-lg inline-block">
              Black Car Service
            </p>
            <h1 className="serviceh1">
              First-Class Travel: How to Elevate Your <br />
              <span className="main_color">
                {" "}
                Next Vacation with a Luxury Car Service in New Jersey?
              </span>
            </h1>
          </div>
        </div>
      </div>
      <div className=" flex justify-between  mx-auto max-w-7xl px-4 pt-4">
        <div className="border-1 px-4 rounded-lg border-[#2B3252] text-[#2B3252]">
          Est. Reading Time: 6 mins 2 sec
        </div>
        <div>
          <div className="bg-[#2B3252] text-white px-2 p-1 rounded-lg">
            7 Nov 2024
          </div>
        </div>
      </div>
      <div className=" flex justify-end  mx-auto max-w-7xl pt-10 px-6 ">
        <Sticky />
      </div>

      <div className=" mx-auto  max-w-5xl  px-6">
        {item.content && <p className="blogcontent">{item.content}</p>}
        {item.content2 && <p className="blogcontent">{item.content2}</p>}
        {item.content3 && (
  <p
    className="blogcontent"
    dangerouslySetInnerHTML={{ __html: item.content3 }}
  ></p>
)}
      </div>
    </>
  );
}

export default hero;
